import {IFarmInputProduct, IInputMessage} from 'constants/interfaces';
import {_GetSoilPath, _NumberWithSpaces} from 'constants/index';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Typography,
} from '@material-ui/core';
import React from 'react';
import moment from 'moment';

export const ProductReplacementMessage = (props: {
  myProfileImage?: string;
  farmerProfileImage?: string;
  message: IInputMessage;
}) => {
  const {myProfileImage, farmerProfileImage, message} = props;
  const isSent = message.senderType === 'SUPPLIER';
  const isReceived = props.message.senderType === 'FARMER';

  return (
    <Box
      key={message.id}
      className={
        isSent ? 'sent-message-container-2' : 'received-message-container-2'
      }
    >
      {isReceived && (
        <Box mr={2}>
          <Avatar src={farmerProfileImage} className={'avatar'} />
        </Box>
      )}
      <Box>
        <Card
          className={isSent ? 'sent-message' : 'received-message'}
          variant="outlined"
        >
          <Box className="product-replacement-container">
            <Box className="title-container">
              <Typography variant="overline">
                Product Replacement Request
              </Typography>
            </Box>
            <Box mb={1}>
              <Divider />
            </Box>
            <Box className="message-container">
              <Box mb={1}>
                <Typography variant="body2">
                  The following item is not available:
                </Typography>
              </Box>
              <ProductReplacementCard
                product={message.productData!.previousProduct}
                price={message.productData?.previousPrice!}
                quantity={message.productData?.previousQuantity!}
              />
              <Box mt={2} />
              <Box mb={1}>
                <Typography variant="body2" gutterBottom>
                  Would you like to replace it with the following?
                </Typography>
              </Box>
              <ProductReplacementCard
                product={message.productData!.replacementProduct}
                price={message.productData?.price!}
                quantity={message.productData?.quantity!}
              />
            </Box>
            <Box mt={2}>
              <Divider />
            </Box>
            <Box className="footer-container">
              <Typography variant="overline">
                {message.productData?.response}
              </Typography>
            </Box>
          </Box>
        </Card>
        <Box
          className="caption-container"
          justifyContent={isSent ? 'flex-end' : null}
        >
          <Typography variant="caption" color="textSecondary">
            {moment(message.date).calendar()}
          </Typography>
        </Box>
      </Box>
      {isSent && (
        <Box ml={2}>
          <Avatar src={myProfileImage} className={'avatar'} />
        </Box>
      )}
    </Box>
  );
};

const ProductReplacementCard = (props: {
  product: IFarmInputProduct;
  price: number;
  quantity: number;
}) => {
  const {price, product, quantity} = props;
  return (
    <Card variant="outlined" className="product-replacement-card">
      <CardMedia
        className="image"
        image={product.image || _GetSoilPath()}
        title={product.name}
      />
      <CardContent className="body">
        <Box className="row">
          <Typography variant="body2">{product.name}</Typography>
        </Box>
        <Box className="row">
          <Typography variant="body2">{product.category}</Typography>
        </Box>
        <Box className="row">
          <Typography variant="body2">
            {quantity} x R {_NumberWithSpaces(props.price)}
          </Typography>
        </Box>
        <Box className="row">
          <Typography variant="body2" color="primary" className="total">
            R {_NumberWithSpaces(price * quantity)}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
